import { render, staticRenderFns } from "./delete_modal.vue?vue&type=template&id=6a2d8935&scoped=true&"
import script from "./delete_modal.vue?vue&type=script&lang=js&"
export * from "./delete_modal.vue?vue&type=script&lang=js&"
import style0 from "./delete_modal.vue?vue&type=style&index=0&id=6a2d8935&prod&lang=scss&scoped=true&"
import style1 from "./delete_modal.vue?vue&type=style&index=1&id=6a2d8935&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d8935",
  null
  
)

export default component.exports